import { useEffect, useState } from 'react';
import { getIndex, getYearIndex, YearData } from '../services/api';

export interface ArchiveYear extends YearData { latestMonth: string | null; href: string | null; }
export function archiveUrl(year: string, month: string): string {
    return '/?' + new URLSearchParams({ page: 'gallery', root: 'recent', year, month: month.padStart(2, '0') });
}

export function useArchiveYears(enabled = true) {
    const [years, setYears] = useState<ArchiveYear[]>([]);
    const [loading, setLoading] = useState(enabled);
    const [error, setError] = useState(false);
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        if (!enabled) return;
        let active = true;
        setLoading(true); setError(false); setYears([]);
        getIndex().then(async index => {
            const available = index.years.filter(item => item.count > 0).sort((a, b) => b.year.localeCompare(a.year));
            const results = await Promise.allSettled(available.map(async year => {
                const data = await getYearIndex(year.year);
                const months = data.months.filter(item => item.count > 0 && /^(0?[1-9]|1[0-2])$/.test(item.month))
                    .map(item => item.month.padStart(2, '0')).sort((a, b) => b.localeCompare(a));
                return { ...year, latestMonth: months[0] || null, href: months[0] ? archiveUrl(year.year, months[0]) : null };
            }));
            if (!active) return;
            setYears(results.flatMap(result => result.status === 'fulfilled' ? [result.value] : []));
            setError(results.some(result => result.status === 'rejected'));
        }).catch(() => { if (active) setError(true); }).finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [enabled, attempt]);
    return { years, loading, error, latestHref: !loading && !error ? years.find(year => year.href)?.href || null : null, retry: () => setAttempt(value => value + 1) };
}
